/* eslint-disable camelcase */
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import superChatActions from 'ai/actions/superChatActions';
import { superChatSelector } from 'ai/selectors/superChatSelector';
import sdnApi from 'ai/services/sdn';
import { getGENAIAnonymousId } from 'ai/utils/sessionStorage';
import { ENTRYPOINTS } from 'ai/constants/superchat';
import { isGenAINewUIEnabledWithRCPS, getEcid } from 'ai/utils/aiBeautyChat';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/EntryPoint/locales', 'AIChat');

const { entryPointPrompts } = sdnApi;

const localization = createStructuredSelector({
    new: getTextFromResource(getText, 'new'),
    aiChatInputPlaceholderCms: getTextFromResource(getText, 'aiChatInputPlaceholderCms')
});

const functions = (dispatch, _ownProps) => ({
    fetchEntryPointPromptsCms: async (sid, clientId, anonymousId) => {
        if (!sid) {
            Sephora.logger.error('SuperChat: skipping CMS entry-point prompts fetch without sid', { sid });

            return null;
        }

        const payload = {
            sid,
            page: ENTRYPOINTS.CMS,
            clientId,
            anonymousId,
            ecid: getEcid()
        };

        return entryPointPrompts(payload);
    },
    handlePromptClick: (prompts, sid, selectedPrompt = null) => {
        const data = {
            entrypoint: ENTRYPOINTS.CMS,
            sid,
            selectedPrompt,
            source: 'cms-entry'
        };

        dispatch(superChatActions.showSuperChat(true, prompts, data));
    },
    updatePrompts: prompts => {
        dispatch(superChatActions.setContextPrompts(prompts));
    }
});

const fields = createSelector(
    localization,
    coreUserDataSelector,
    superChatSelector,
    (locales, user, superChat) => {
        const clientId = user?.biId;
        let anonymousId = undefined;

        if (!Sephora.isNodeRender) {
            anonymousId = getGENAIAnonymousId();
        }

        const chatName = superChat?.config?.meta?.try_chat_name || '';
        const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

        return {
            localization: locales,
            chatName,
            clientId,
            anonymousId,
            isRequestInFlight: superChat?.isRequestInFlight || false,
            isGenAINewUIEnabled
        };
    }
);

const withContentPageProps = wrapHOC(connect(fields, functions));

export {
    withContentPageProps, fields, functions
};
